export const tr = {
    'try-later': 'Hata oluştu. Lütfen, tekrar deneyin.'
};
